import React from 'react';
import { useNavigate } from 'react-router-dom';
import ExecutiveTraining from '../components/Features/ExecutiveTraining';

/**
 * Full-page entry point for Flash Academy. The training experience itself is
 * the same component used by the feature modal, with navigation tied to routes.
 */
const Academy: React.FC = () => {
  const navigate = useNavigate();

  return <ExecutiveTraining isOpen onClose={() => navigate('/dashboard')} />;
};

export default Academy;
